module.exports = __webpack_public_path__ + "static/img/lhlb.8bcfc5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/lhlb.jpg
// module id = 7YzY
// module chunks = 0